import React from 'react';
import PropTypes from 'prop-types';

const Label = ({ children, id, required, ...rest }) => <label className="c-form__label" htmlFor={id} {...rest}>
    {children}
    {required && (
      <abbr className="c-form__required" title="Required">
        *
      </abbr>
    )}
  </label>

export default Label;

Label.propTypes = {
  children: PropTypes.node,
  id: PropTypes.string.isRequired,
  required: PropTypes.bool,
};
Label.defaultProps = {
  children: null,
  required: false,
};
